module.exports = __webpack_public_path__ + "static/media/asset_error.096d7bd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asset_error.svg
// module id = 845
// module chunks = 0